// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-pattern pattern-footer-1"></div>
            <div className="footer-pattern pattern-footer-2"></div>

            <div className="container-footer">
                <div className="footer-content">
                    <div className="footer-info">
                        <h3>Samir Dutta</h3>
                        {/* <p className="bengali-text" style={{ marginBottom: '0.5rem', opacity: 0.8 }}>সমীর দত্ত</p> */}
                        <p>Folk Modernist Artist</p>
                        <p>Creating authentic cultural narratives since 1990</p>
                        <div className="social-links">
                            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-facebook"></i>
                            </a>
                            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-twitter"></i>
                            </a>
                            <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-linkedin"></i>
                            </a>
                            <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-youtube"></i>
                            </a>
                        </div>
                    </div>

                    <div className="footer-nav">
                        <h3>Explore</h3>
                        <ul>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/about">About</Link>
                            </li>
                            <li>
                                <Link to="/gallery">Gallery</Link>
                            </li>
                            <li>
                                <Link to="/exhibition">Exhibitions</Link>
                            </li>
                            <li>
                                <Link to="/commission">Customized Order</Link>
                            </li>
                            <li>
                                <Link to="/testimonials">Testimonials</Link>
                            </li>
                            <li>
                                <Link to="/contact">Contact</Link>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-nav">
                        <h3>Art Categories</h3>
                        <ul>
                            <li>
                                <Link to="/gallery">Mythology & Deities</Link>
                            </li>
                            <li>
                                <Link to="/gallery">Folk Narratives</Link>
                            </li>
                            <li>
                                <Link to="/gallery">Contemporary Abstract</Link>
                            </li>
                            <li>
                                <Link to="/gallery">Hindu Iconography</Link>
                            </li>
                            <li>
                                <Link to="/gallery">Divine Relationships</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Samir Dutta. All Rights Reserved.</p>
                    <p style={{ marginTop: '0.5rem', fontSize: '0.9rem', opacity: 0.8 }}>
                        Website designed by <a href='https://alphaaiservice.com/' target='_blank' rel="noopener noreferrer" style={{ color: 'white' }}>Alpha AI Service</a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;